import axios from '../utils/axios';
import  { v4 as uuidv4 } from 'uuid';

const SERVICE_URL = '/products/variants';

export const getProductVariantsList = async (
    searchTerm,
    page,
    rowsPerPage,
    LastEvaluatedKey
) => {
    try {
        let response = await axios.post(
            `${SERVICE_URL}`
            , 
            { 
                searchTerm,
                page,
                rowsPerPage,
                LastEvaluatedKey
            }
        );
        return response.data;
    } catch (error) {
        return {
            Items: [], 
            LastEvaluatedKey: {},
            totalPages: 1
        };
    }
}

export const productVariantsGenerate = async (formData) => {

    try {
        // console.log("PROD VAR FORM CREATE", formData)

        let response = await axios.post(`${SERVICE_URL}/generate`, formData );
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productVariantsCreate = async (formData) => {

    try {
        // console.log("PROD VAR FORM CREATE", formData)

        let response = await axios.post(`${SERVICE_URL}/create`, formData );
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productVarianStockUpdate = async (data) => {

    try {
        let response = await axios.put(`${SERVICE_URL}/stock`, data );
        return response.data;
    } catch (error) {
        return {
            result: false,
            error
        };
    }
}

export const productVarianStockUpdateByCsv = async (items) => {
    return axios.post(`${SERVICE_URL}/update-csv`, { items } )
}